import { createElement } from "react";
import toast from "react-hot-toast";
import { FaEnvelope, FaUser } from "react-icons/fa6";

const pWithMessage = (message: string) =>
  createElement("p", { dangerouslySetInnerHTML: { __html: message } });
export const showNewMessageNotification = (
  contactId: number,
  companyId: number,
  message: string
) => {
  toast(message, {
    id: `${companyId}-${contactId}-${Date.now()}`,
    position: "bottom-right",
    duration: 5000,
    icon: createElement(FaEnvelope, { className: "text-lg" }),
    className:
      "notification-toast cursor-pointer h-16 w-72 !bg-accent !text-white hover:!opacity-90 !rounded-lg",
  });
};

export const showOnlinePersonNotification = (message: string) => {
  toast(message, {
    position: "bottom-left",
    duration: 5000,
    icon: createElement(FaUser, { className: "text-lg" }),
    className: "h-16 w-72 !bg-accent !text-white hover:!opacity-90 !rounded-lg",
  });
};

export const showErrorFeedback = (message: string) => {
  toast.error(pWithMessage(message), {
    position: "bottom-right",
    duration: 20000,
    className: "error-toast cursor-pointer h-16 w-72 hover:!opacity-90",
  });
};

export const showSuccessFeedback = (message: string) => {
  toast.success(message, {
    position: "bottom-right",
    duration: 5000,
    icon: null,
    className: "success-toast h-16 w-72 bg-white hover:!opacity-90",
  });
};
